<template>
  <div class="image image--exit" v-if="isExit"></div>
  <div class="image image--return" v-else></div>
</template>

<script>
  export default {
    props: {
      isExit: Boolean,
    },
  }
</script>

<style lang="scss">
  @import "../../../scss/variables";

  .image {
    width: 30px;
    position: relative;

    &--exit::before,
    &--return::before {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 14px;
      height: 18px;
      pointer-events: none;
    }
    &--exit {
      background-color: $sortie;
      &::before {
        content: url("../../../../static/img/sortie.svg");
      }
    }
    &--return {
      background-color: $rentree;
      &::before {
        content: url("../../../../static/img/rentree.svg");
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ExitReturnImage.vue?da6836ea